import type { ReactNode } from 'react';
import { Link, useParams } from 'react-router-dom';
import { RecordStepper } from '../records/RecordStepper';
import { PageHead, RecordLink, StatusPill } from '../ui/chrome';

export function OfferWorkspace({
  number, title, customer, status, revision, saveState, tab, proposalTo, quotationTo, orderTo, orderLabel, reviewTo, onSelectTab, onMissing, actions, children,
}: {
  number?: string;
  title: string;
  customer?: string;
  status?: string;
  revision?: string;
  saveState?: string;
  tab: string;
  proposalTo?: string;
  quotationTo?: string;
  orderTo?: string;
  orderLabel?: string;
  reviewTo?: string;
  onSelectTab?: (id: string) => void;
  onMissing?: (id: 'proposal' | 'quotation') => void;
  actions?: ReactNode;
  children: ReactNode;
}) {
  const { id = '' } = useParams();
  const tabs = [
    { id: 'overview', label: 'Overview', to: proposalTo ? `${proposalTo}?tab=overview` : undefined },
    { id: 'proposal', label: 'Proposal', to: proposalTo },
    { id: 'quotation', label: 'Quotation', to: quotationTo },
    { id: 'activity', label: 'Activity', to: proposalTo ? `${proposalTo}?tab=activity` : undefined },
  ];
  return (
    <div>
      <PageHead
        stepper={id ? <RecordStepper listUrl="/api/commercial" id={id} basePath="/proposals" /> : null}
        crumbs={[{ label: 'Sales offers', to: '/quotations' }, { label: number || 'New' }]}
        back={{ label: 'Back to offers', to: '/quotations' }}
        title={title || 'New offer'}
        meta={
          <>
            {customer ? <span>{customer}</span> : null}
            <StatusPill palette="offer" value={status || 'Draft'} />
            {orderTo ? <RecordLink to={orderTo} backLabel={`Back to ${number || 'offer'}`}>{orderLabel || 'Customer order'}</RecordLink> : null}
            {revision ? <span>Revision {revision}</span> : null}
            {saveState ? <span>{saveState === 'saving' ? 'Saving' : saveState === 'failed' ? 'Failed' : 'Saved just now'}</span> : null}
          </>
        }
        actions={actions}
      />
      <div className="mb-4 flex gap-1 border-b border-[var(--bo-border)]">
        {tabs.map((item) => {
          const on = tab === item.id;
          const className = `border-b-2 px-3 py-2 text-sm ${on ? 'border-[#895CF6] text-[var(--bo-text)]' : 'border-transparent text-[var(--bo-muted)]'}`;
          if (onSelectTab) return <button key={item.id} type="button" className={className} onClick={() => onSelectTab(item.id)}>{item.label}</button>;
          if (item.to) return <Link key={item.id} className={className} to={item.to}>{item.label}</Link>;
          const missing = item.id === 'proposal' || item.id === 'quotation' ? item.id : undefined;
          if (onMissing && missing) return <button key={item.id} type="button" className={className} onClick={() => onMissing(missing)}>{item.label}</button>;
          return <span key={item.id} className={className}>{item.label}</span>;
        })}
        {reviewTo ? null : null}
      </div>
      {children}
    </div>
  );
}
